import { useState, useCallback } from "react"
import { Outlet } from "react-router-dom"
import { Sidebar } from "./Sidebar"
import { MobileSidebar } from "./MobileSidebar"
import { TopBar } from "./TopBar"

export function DashboardLayout() {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false)

  const handleCloseMobileSidebar = useCallback(() => {
    setIsMobileSidebarOpen(false)
  }, [])

  const handleOpenMobileSidebar = useCallback(() => {
    setIsMobileSidebarOpen(true)
  }, [])

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      {/* Desktop Sidebar - hidden on mobile */}
      <div className="hidden lg:flex">
        <Sidebar />
      </div>

      {/* Mobile Sidebar - only on mobile/tablet */}
      <MobileSidebar
        isOpen={isMobileSidebarOpen}
        onClose={handleCloseMobileSidebar}
      />

      {/* Main Content */}
      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Top Bar */}
        <TopBar onMenuClick={handleOpenMobileSidebar} />

        {/* Page Content with premium gradient background */}
        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8 relative ambient-bg">
          {/* Ambient gradient orbs - removed since orbs are display:none in CSS */}

          <div className="mx-auto max-w-7xl relative z-10">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
